var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/rocket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.00001 22C4.00001 23.68 3.33334 28.6667 3.33334 28.6667C3.33334 28.6667 8.32001 28 10 26C10.9467 24.88 10.9333 23.16 9.88001 22.12C9.36175 21.6253 8.67907 21.3395 7.96298 21.3174C7.24689 21.2952 6.54785 21.5383 6.00001 22Z",
    stroke: "#014935",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 20L12 16C12.7095 14.1592 13.6029 12.3947 14.6667 10.7333C16.2202 8.2493 18.3835 6.20405 20.9507 4.79211C23.5178 3.38016 26.4036 2.64848 29.3333 2.66665C29.3333 6.29332 28.2933 12.6667 21.3333 17.3333C19.6492 18.3983 17.8625 19.2916 16 20Z",
    stroke: "#014935",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 16H5.33334C5.33334 16 6.06668 11.96 8.00001 10.6667C10.16 9.22667 14.6667 10.6667 14.6667 10.6667",
    stroke: "#014935",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16 20V26.6666C16 26.6666 20.04 25.9333 21.3333 24C22.7733 21.84 21.3333 17.3333 21.3333 17.3333",
    stroke: "#014935",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
export default __webpack_public_path__ + "static/media/rocket-icon.2187b380a7ff6ceaba95baf279d21fef.svg";
export { ForwardRef as ReactComponent };